import { Component, OnInit, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { ApiService } from 'src/app/service/api.service';
import { MatDialog } from "@angular/material/dialog";
import { ConfirmationDialogComponent } from '../../confirmation-dialog/confirmation-dialog.component';

declare var jQuery: any;
declare var onLoadMethods: any;
// declare var onReadyFunctions: any;

@Component({
  selector: 'app-header1',
  templateUrl: './header1.component.html',
  styleUrls: ['./header1.component.css']
})
export class Header1Component implements OnInit {

  isLargeScreen: boolean = window.innerWidth <= 768; // Set breakpoint width here
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isLargeScreen = (window.innerWidth <= 768); // Adjust width for responsive view
  }

  constructor(private router: Router,public api:ApiService,private dialog:MatDialog) { 
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isNavOpen = false; // Close the nav on route change
      }
    });
  }
  
  applicant_token:any
  loginCheck(data=''){
    console.log("loginCheck",data);
    this.applicant_token=this.api.decryptData(localStorage.getItem('applicant-token-detail'))
    console.log("this.applicant_token",this.applicant_token);
    
  }



  ngOnInit(): void {
    this.toggleNav() 
    this.applicant_token=this.api.decryptData(localStorage.getItem('applicant-token-detail'))
    console.log("ngOnInit this.applicant_token",this.applicant_token);
  }

  logout()
  {
    let dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      data: 'Are you sure want to logout?'
    });
      dialogRef.afterClosed().subscribe(result => {
        if(result) {
          if(this.api.regCountInterval)
            clearInterval(this.api.regCountInterval);
          let response= localStorage.getItem('token-detail');
          let decResponse=this.api.decryptData(response);
          this.api.applicationLogoutLog();
          
        }
        dialogRef=null;
      });
  }
  // toggleNav() {
  //   this.isNavOpen = !this.isNavOpen;
    
  //   // If using animations, ensure any library (like GSAP) has defined zIndex values
  //   const navElement = document.querySelector('.navbar-collapse');
    
  //   if (this.isNavOpen) {
  //     // Ensure proper z-index is defined when opening
  //     navElement.style.zIndex = '1000'; 
  //   } else {
  //     // Clean up z-index when closing, if needed
  //     navElement.style.zIndex = ''; // Reset to original state if needed
  //   }
  // }
  
  
  isNavOpen = false;

  toggleNav() {
      this.isNavOpen = !this.isNavOpen; // Toggle the state
  }
}
